// removed by extract-text-webpack-plugin
module.exports = {"miniProgress":"app-1GdGyit9","progressWrap":"app-2HLFQKXO","progress":"app-HKI6klPu","target":"app-3vzAjofy"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/charts/MiniProgress/index.less
// module id = 610
// module chunks = 0